/* @ngInject */
function AssetPreviewTabResultsController ($scope, $state, $translate, $rootScope, AssetPreviewService, TemplateService, Utils, ToastService) {
  $scope.cards = []
  $scope.loading = true
  $scope.exportDisabled = false
  $scope.sincePublication = null

  const api = {
    _getAssetResults,
    _getTemplateResults,
    _handleExportError,
    _getSincePublicationText
  }
  this.getApi = () => api

  $scope.$watchCollection('template', () => {
    $scope.loading = true
    $scope.cards = []

    TemplateService.getTemplateDetailsForPreview($scope.template.id).then((details) => {
      $scope.templateDetails = details
      $scope.sincePublication = api._getSincePublicationText(details)

      if (details.isCustomizable) {
        api._getTemplateResults()
      } else {
        api._getAssetResults()
      }
    })
  })

  function _getSincePublicationText (details) {
    const locale = $rootScope.oUser.locale
    const dateObject = new Date(details.createdAt)
    const date = Intl.DateTimeFormat(locale).format(dateObject)

    return $translate.instant('sincePublish', { date })
  }

  $scope.exportAssetResults = () => {
    const { id, createdAt, isCustomizable } = $scope.templateDetails
    const endDate = new Date().toISOString()
    $scope.exportDisabled = true

    AssetPreviewService.exportAssetInsights($scope.assetSlug, isCustomizable, id, createdAt, endDate).then(({ signedUrl }) => {
      Utils.downloadFile(signedUrl)
      $scope.exportDisabled = false
    }).catch(api._handleExportError)

    ToastService.showSuccessToast($translate.instant('afterDownloadParagraph'))
  }

  function _handleExportError () {
    ToastService.showErrorToast($translate.instant('somethingWentWrongTryAgainMsg'))
  }

  $scope.goToAnalytics = () => {
    const defaultAnalyticsPage = 'overview'

    $state.go('analytics.dashboard', {
      slug: defaultAnalyticsPage
    })
  }

  function _getAssetResults () {
    const { id, createdAt } = $scope.templateDetails
    const endDate = new Date().toISOString()
    $scope.assetSlug = 'preview-asset'

    AssetPreviewService.getAssetInsights(id, createdAt, endDate).then(res => {
      $scope.cards = res
      $scope.loading = false
    })
  }

  function _getTemplateResults () {
    const { id, createdAt, needApproval } = $scope.templateDetails
    const endDate = new Date().toISOString()
    $scope.assetSlug = needApproval ? 'preview-customizable-asset-with-approval' : 'preview-customizable-asset'

    AssetPreviewService.getCustomizableAssetInsights(id, createdAt, endDate, needApproval).then(res => {
      $scope.cards = res
      $scope.loading = false
    })
  }
}

export { AssetPreviewTabResultsController }
